import { diagnosisService } from "@/stores/services/diagnosisServices";
import { skipToken } from "@reduxjs/toolkit/query";

export function useDriverData(companyId: number, diagnosisId?: number) {
  const { data: driverByCompanyid, isFetching: isLoadingDriverByCompany } =
    diagnosisService.useFindDriversByCompanyIdQuery(
      diagnosisId && diagnosisId > 0
        ? { companyId, diagnosisId }
        : skipToken,
    );

  return {
    driverByCompanyid,
    isLoadingDriverByCompany,
  };
}
